import React from "react";

export const Heading = ({ children, center = false }) => {
	return (
		<h1 className={`font-bold text-2xl ${center && "text-center"}`}>
			{children}
		</h1>
	);
};
